import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container, Box, TextField, InputAdornment, CircularProgress, Stack,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import fundedAPI from '../../api/funded';
import FundedNav from './FundedNav';
import ClientTable from '../../components/funded/ClientTable';

export default function ClientsView() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState({ total: 0, page: 1, pages: 1 });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState('totalCommissions');
  const [order, setOrder] = useState('desc');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fundedAPI.getClients({ search, page, sortBy, order, limit: 25 });
      setRows(res.data.data || []);
      setMeta({ total: res.data.total, page: res.data.page, pages: res.data.pages });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [search, page, sortBy, order]);

  useEffect(() => {
    const t = setTimeout(load, search ? 300 : 0);
    return () => clearTimeout(t);
  }, [load, search]);

  const handleSort = (col) => {
    if (sortBy === col) setOrder(order === 'asc' ? 'desc' : 'asc');
    else { setSortBy(col); setOrder(col === 'business_name' ? 'asc' : 'desc'); }
    setPage(1);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <FundedNav title="Funded Clients" subtitle="The funded book — all clients with closed deposits" />

      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        <TextField
          size="small"
          placeholder="Search by business name, EIN, email…"
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
          sx={{ width: { xs: '100%', sm: 360 } }}
          InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
        />
      </Stack>

      {loading ? (
        <Box display="flex" justifyContent="center" py={8}><CircularProgress /></Box>
      ) : (
        <ClientTable
          rows={rows}
          total={meta.total}
          page={meta.page}
          pages={meta.pages}
          sortBy={sortBy}
          order={order}
          onSort={handleSort}
          onPageChange={setPage}
          onOpen={(r) => navigate(`/sales/funded/clients/${encodeURIComponent(r.client_id)}`)}
        />
      )}
    </Container>
  );
}
